import type { RefObject } from 'react';
import { createContext } from 'react';

import type {
  EasingFunction,
  TransitionDuration,
} from '~/components/ScrollCollapse/debug/ScrollCollapseControls';

export interface ScrollCollapse {
  scrollProgress: number;
  getInterpolatedValue: (max: number, min: number) => number;
  headerRef?: RefObject<HTMLDivElement>;
  // @TODO WMG1-573: Remove these props once the scroll collapse behavior is finalized.
  scrollDistance: number;
  scrollDistanceMax: number;
  setScrollDistanceMax?: (value: number) => void;
  easingFunction?: EasingFunction;
  setEasingFunction?: (value: EasingFunction) => void;
  transitionDuration: TransitionDuration;
  setTransitionDuration?: (value: TransitionDuration) => void;
}

export const ScrollCollapseContext = createContext<ScrollCollapse | undefined>(
  undefined,
);

ScrollCollapseContext.displayName = 'ScrollCollapseContext';
